// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '../outgoing-payment/types';

export function peruvianOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  return {
    country: 'pe',
    document: userInputValues['peruvianDocument'],
    document_type: userInputValues['peruvianDocumentType'],
    zipcode: userInputValues['peruvianZipcode'],
    state: userInputValues['peruvianState'],
    city: userInputValues['peruvianCity'],
    address: userInputValues['peruvianAddress'],
    street_number: userInputValues['peruvianStreetNumber'],
    street_complement: userInputValues['peruvianStreetComplement'],
    phone_number: userInputValues['peruvianPhoneNumber'],
  };
}
